/**
 * check if the call should be made using the MFE softphone instead of quick call
 * @param number - The phone number to check
 */
export const shouldUseSoftPhone = (number: string) => {
  const EMERGENCY_NUMBERS = [
    '911',
    '933', // for testing so that we don't call 911
  ];
  // emergency numbers or voice mail should be called using MFE softphone
  return EMERGENCY_NUMBERS.includes(number) || number.startsWith('*');
};
